<template>
    <div>
        <sammio-actions></sammio-actions>

        <div class="container">
            <div class="row">
                <section class="col-md-8 my-5 " id="sammio__element--main">
                  <div class="mb-5" v-html="infoContent"></div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import * as http from "../store/http";
    import SammioActions from "./SammioActions";

    export default {
        name: "SammioHelp",
        components: {
            SammioActions
        },
        props: {
            articleType: String
        },
        data() {
            return {
                infoContent: this.getInfoContent()
            }
        },
        methods: {
            getInfoContent() {
                http.get('/get-content', this.$store.state.portletId, {info: this.articleType})
                    .then(response => {
                        this.infoContent = response.data.content
                    })
                    .catch(error => {
                        //this.$store.dispatch('setErrorMessages', { hasErrors: true,  data: { type: 'statutes', code: '', text: i18n.t('sammio.errors.common_error') } })
                        //this.error = true
                    })
            }
        },
        watch: {
            $route(to, from) {
                if (this.$router.currentRoute.name === this.articleType) {
                    this.getInfoContent()
                }
            },
            locale(lang) {

                if (this.$router.currentRoute.name === this.articleType) {
                    this.getInfoContent()
                }
            }
        }
    }
</script>

<style scoped>

</style>